import React from 'react'
import Modal from 'react-modal'
import { ReactComponent as ModalErrorSvg } from '../../images/ModalError.svg'
import css from './ModalSuccessful.module.css'
Modal.setAppElement('#root')

const ModalError = ({ isOpen, onRequestClose }) => {
	return (
		<Modal
			isOpen={isOpen}
			onRequestClose={onRequestClose}
			contentLabel='Error'
			className={css.modalContent}
			overlayClassName={css.modalOverlay}
		>
			<ModalErrorSvg className={css.modalSvg} />
			<h2 className={css.modalTitle}>
				Wystąpił błąd podczas wysyłania formularza.
			</h2>
			<p className={css.modalMessage}>
				Prosimy spróbować ponownie później lub skontaktować się bezpośrednio z
				nami.
			</p>
			<button className={css.closeButton} onClick={onRequestClose}>
				Zamkni
			</button>
		</Modal>
	)
}

export default ModalError
